module.exports = __webpack_public_path__ + "static/media/expedia-logo-icon.2f17f88e.png";